<template>
    <button class="v-nav-mobile-toggle" @click="toggle()">
        <slot>
            <!---->
        </slot>
    </button>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');

    @Component
    export default class NavMobileToggle extends BaseComponent {
        @ui.Mutation('toggleMenu') protected toggle: () => void;
    }
</script>
